// extracted by mini-css-extract-plugin
export default {"contCards":"Paginado_contCards__JXmM1","pageNumbers":"Paginado_pageNumbers__zJLub","active":"Paginado_active__YYfEU","loading":"Paginado_loading__veWLC"};